import { render, staticRenderFns } from "./prixmoyen_update.vue?vue&type=template&id=8c9496e2&"
import script from "./prixmoyen_update.vue?vue&type=script&lang=js&"
export * from "./prixmoyen_update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports